<template>
    <div class="wizard__head">
        <h1 class="wizard__head-title">
            <span class="wizard__head-title-inner" v-if="title" v-html="title"></span
            ><img
                v-if="help"
                v-tooltip="help"
                v-bind:src="generateMediaUrl({ path: 'static/ui/misc/help.svg' })"
                class="help-icon"
                width="20"
                alt=""
            />
        </h1>
        <h2 class="wizard__head-subtitle" v-if="subtitle" v-html="subtitle"></h2>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    data() {
        return {};
    },
    components: {},
    methods: {},
    computed: {
        ...mapGetters(['generateMediaUrl'])
    },
    created() {},
    mounted() {},
    props: {
        title: String,
        subtitle: String,
        help: String
    }
};
</script>
